import { render, staticRenderFns } from "./SearchForm.vue?vue&type=template&id=6d58be5d&scoped=true&"
import script from "./SearchForm.vue?vue&type=script&lang=js&"
export * from "./SearchForm.vue?vue&type=script&lang=js&"
import style0 from "./SearchForm.vue?vue&type=style&index=0&id=6d58be5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d58be5d",
  null
  
)

/* custom blocks */
import block0 from "./SearchForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports